import { orgAdd, orgAddOrgUsers } from "@/apis/org";
import { RootState } from "@/store";
import { Org, OrgAdd } from "@/types/org";
import { Form, Input, Modal, notification } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { SelectUsers } from "./Selector";

interface OrgAddModalProps {
  open: boolean;
  onOk: (orgInfo: Org) => void;
  onCancel: () => void;
}

export const OrgAddModal: FC<OrgAddModalProps> = ({ open, onOk, onCancel }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<OrgAdd>();
  const { curUser } = useSelector((state: RootState) => state.userReducer);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (open && curUser) form.setFieldsValue({ pId: '', users: [curUser.id] });
  }, [open, form, curUser]);

  let formUsers = Form.useWatch(["users"], form);

  useEffect(() => {
    if (!!!formUsers?.length) form.setFieldValue("users", [curUser.id])
  }, [formUsers]);

  const handleSubmit = async (values: OrgAdd) => {
    if (loading) return;
    try {
      setLoading(true);
      let orgNew = await orgAdd(values);
      if (!!orgNew && values.users?.length) {
        orgNew = await orgAddOrgUsers(orgNew.id, values.users);
      }
      onOk(orgNew);
    } catch (error) {
      notification.error({ message: t('common.addErr') });
    } finally { setLoading(false) };
  };

  return (
    <Modal title={t("org.addOrg")} open={open} width={600}
      onOk={form.submit} onCancel={onCancel} destroyOnClose
      okButtonProps={{ disabled: loading }} maskClosable={false}>
      <Form<OrgAdd> form={form} onFinish={handleSubmit}>
        <Form.Item<OrgAdd> name="pId" hidden />
        <Form.Item<OrgAdd> name="name" label={t('org.name')} rules={[{ required: true, message: t('org.enterName') }]}>
          <Input placeholder={t('org.enterName')} maxLength={100} showCount />
        </Form.Item>
        <Form.Item<OrgAdd> name="desc" label={t('org.desc')}>
          <Input.TextArea placeholder={t('org.enterDesc')} maxLength={1000} showCount />
        </Form.Item>
        <Form.Item<OrgAdd> name="users" label={t('org.members')}>
          <SelectUsers placeholder={t('org.selMem')} allowClear
            disabledUsers={[curUser.id]}
            defaultList={[curUser]}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}